import request from '@/config/axios'

// 订单跟进记录 VO
export interface OrderFollowUpVO {
  id?: number // 编号
  orderId?: number // 归属订单（项目）编号
  projectName?: string // 项目名称（取自归属订单）
  projectManagerId?: number // 项目经理（取自归属订单）
  projectManagerName?: string
  no?: string // 单号（dd- + 5 位自增，后端生成）
  type?: number // 跟进方式（字典 crm_follow_up_type）
  content?: string // 跟进内容
  devSummary?: string // 开发汇总
  bugSummary?: string // Bug 汇总
  todayWork?: string // 今日工作内容
  nextPlan?: string // 下一步工作计划
  pendingMatter?: string // 待处理事项
  followTime?: string // 跟进时间
  followerUserId?: number // 跟进人（申请人）
  followerUserName?: string
  followerDeptName?: string // 申请人部门
  createTime?: Date // 创建时间
}

// 订单跟进记录 API
export const OrderFollowUpApi = {
  /**
   * 查询订单跟进记录分页
   *
   * 两个页签共用同一个接口：
   * - 「全部跟进记录」→ 不传 onlyMine
   * - 「我的跟进记录」→ onlyMine = true（后端强制 followerUserId = 当前用户）
   */
  getOrderFollowUpPage: async (params: any) => {
    return await request.get({ url: `/crm/order-follow-up/page`, params })
  },

  // 查询订单跟进记录详情
  getOrderFollowUp: async (id: number) => {
    return await request.get({ url: `/crm/order-follow-up/get?id=` + id })
  },

  // 新增订单跟进记录
  createOrderFollowUp: async (data: OrderFollowUpVO) => {
    return await request.post({ url: `/crm/order-follow-up/create`, data })
  },

  // 修改订单跟进记录
  updateOrderFollowUp: async (data: OrderFollowUpVO) => {
    return await request.put({ url: `/crm/order-follow-up/update`, data })
  },

  // 删除订单跟进记录
  deleteOrderFollowUp: async (id: number) => {
    return await request.delete({ url: `/crm/order-follow-up/delete?id=` + id })
  },

  // 导出订单跟进记录
  exportOrderFollowUp: async (params: any) => {
    return await request.download({ url: `/crm/order-follow-up/export`, params })
  }
}
